import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import PageLayout from '../components/PageLayout'
import Seo from '../components/Seo'

export default function About() {
  const { t } = useTranslation()

  return (
    <PageLayout title={t('about.title')}>
      <Seo title={t('about.title')} description="Saatbahane - About Us. Luxury Watch Experts in Istanbul." />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-12">
        <div>
          <p className="mb-6 text-xl font-medium leading-relaxed text-gold-400">{t('about.p1')}</p>
          <p className="text-lg font-light leading-relaxed text-gray-300">{t('about.p2')}</p>
        </div>
        <div className="rounded-2xl border border-gold-500/20 bg-white/5 p-8">
          <h2 className="mb-4 text-2xl font-serif text-white">Vizyonumuz</h2>
          <p className="max-w-2xl font-light text-gray-300">{t('about.vision')}</p>
        </div>
        <p className="text-lg font-light leading-relaxed text-gray-300">{t('about.p3')}</p>
      </motion.div>
    </PageLayout>
  )
}

